<template>
    <div>
        <el-card>
            <div slot="header">
                <el-row type="flex" justify="space-between" style="margin-bottom: 0">
                    <h3>{{ formTitle }}</h3>
                    <el-button v-if="$parent.user_is_admin" type="text" @click="$emit('canceled')">Schliessen</el-button>
                </el-row>
            </div>

            <el-form ref="supplierData" :model="supplierData" label-width="300px" label-position="left" :rules="rules">
                <el-form-item
                        label="Name Supplier"
                        prop="supplier_name">
                    <el-input
                            v-model="supplierData.supplier_name">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="SMTP Host"
                        prop="mail_smtp">
                    <el-input
                            v-model="supplierData.mail_smtp">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="SMTP Port"
                        prop="mail_smtp_port">
                    <el-input
                            v-model.number="supplierData.mail_smtp_port">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="SMTP Verschlüsselung"
                        prop="mail_smtp_encryption">
                    <el-input
                            v-model="supplierData.mail_smtp_encryption">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="SMTP Benutzername"
                        prop="mail_smtp_username">
                    <el-input
                            v-model="supplierData.mail_smtp_username">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="SMTP Passwort"
                        prop="mail_smtp_password">
                    <el-input
                            v-model="supplierData.mail_smtp_password">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="Kontakt-Mail"
                        prop="contact_mail">
                    <el-input
                            v-model="supplierData.contact_mail">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="Zugelassene Anzahl von Panels pro Kunde"
                        prop="max_panels_per_customer">
                    <el-input
                            type="number"
                            v-model="supplierData.max_panels_per_customer">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="Absender-Mail"
                        prop="mail_sender_address">
                    <el-input
                            v-model="supplierData.mail_sender_address">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="Rabatt pro Panel"
                        prop="discount_per_panel">
                    <el-input
                            v-model="supplierData.discount_per_panel">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="Schriftfarbe"
                        prop="font_color">
                    <el-input
                            v-model="supplierData.font_color">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="Hintergrundfarbe"
                        prop="background_color">
                    <el-input
                            v-model="supplierData.background_color">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="Hervorhebungsfarbe"
                        prop="highlight_color">
                    <el-input
                            v-model="supplierData.highlight_color">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="Applikations-URL"
                        prop="permalink_url">
                    <el-input
                            v-model="supplierData.permalink_url">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="Logo"
                        prop="logo">
                    <el-upload
                            :action="''"
                            :show-file-list="!logoUploaded"
                            :file-list="fileList"
                            class="upload-demo"
                            :on-change="uploadAndPreview"
                            :auto-upload="false"
                            :on-remove="handleRemove"
                            list-type="picture">
                        <el-button :loading="uploading" size="small" type="primary">Hochladen</el-button>
                        <div slot="tip" class="el-upload__tip">jpg/png files with a size less than 500kb</div>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button
                            :disabled="uploading"
                            type="primary" @click="submitForm('supplierData')">Speichern
                    </el-button>
                    <el-button
                            :disabled="uploading"
                            @click="cancelForm('supplierData')">Abbrechen
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>
<script>
    /* eslint-disable */
    import { mapGetters } from 'vuex';
    import { CREATE_SUPPLIER, FETCH_SUPPLIERS, UPDATE_SUPPLIER } from '../../../store/types';

    export default {
        name: 'SupplierForm',
        data () {
            return {
                uploadedLogo: new FormData(),
                logoUploaded: false,
                formTitle: '',
                supplierData: {
                    supplier_name: '',
                    mail_smtp: '',
                    mail_smtp_port: '',
                    mail_smtp_username: '',
                    mail_smtp_password: '',
                    contact_mail: '',
                    max_panels_per_customer: '',
                    mail_sender_address: '',
                    discount_per_panel: '',
                    font_color: '',
                    background_color: '',
                    highlight_color: '',
                    permalink_url: '',
                    logo: null,
                },
                fileList: [],
                rules: {
                    supplier_name: [
                        { required: true, message: '', trigger: 'change' },
                    ],
                    mail_smtp: [
                        { required: true, message: '', trigger: 'change' },
                    ],
                    mail_smtp_port: [
                        { required: true, message: '' },
                        { type: 'number', message: '' },
                    ],
                    mail_smtp_username: [
                        { required: true, message: '', trigger: 'change' },
                    ],
                    mail_smtp_password: [
                        { required: true, message: '', trigger: 'change' },
                    ],
                    contact_mail: [
                        { required: true, message: '', trigger: 'change' },
                        { type: 'email', message: 'E-Mail not valid!', trigger: 'change' },
                    ],
                    max_panels_per_customer: [
                        { required: true, message: '', trigger: 'change' },
                    ],
                    mail_sender_address: [
                        { required: true, message: '', trigger: 'change' },
                        { type: 'email', message: 'E-Mail not valid!', trigger: 'change' },
                    ],
                    discount_per_panel: [
                        { required: true, message: '', trigger: 'change' },
                    ],
                    font_color: [
                        {
                            required: false,
                            message: '',
                            trigger: 'change',
                            pattern: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
                        },
                    ],
                    background_color: [
                        {
                            required: false,
                            message: '',
                            trigger: 'change',
                            pattern: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
                        },
                    ],
                    highlight_color: [
                        {
                            required: false,
                            message: '',
                            trigger: 'change',
                            pattern: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
                        },
                    ],
                    permalink_url: [
                        {
                            required: true,
                            message: '',
                            trigger: 'change',
                        },
                    ],
                },
                responseMessage: '',
                uploading: false,
                submitSuccess: false,
            };
        },
        computed: {
            ...mapGetters(['get_supplier', 'get_current_user', 'get_api_url', 'get_auth_token']),
        },
        props: {
            supplierId: {
                type: Number
            },
            formAction: {
                default: 'edit',
                type: String,

            },
        },
        created () {
            switch (this.formAction) {
                case 'edit':
                    this.prepareEditForm();
                    break;
                default:
                    this.prepareCreateForm();
            }
        },
        methods: {
            prepareCreateForm () {
                this.formTitle = 'Neues Supplier';
            },
            prepareEditForm () {
                if (this.$parent.user_is_admin) {
                    this.supplierData = this.get_supplier(this.supplierId);
                    this.setLogo(this.supplierData);
                    this.formTitle = `Bearbeiten ${this.supplierData.supplier_name}`;
                } else {
                    this.$store.dispatch(FETCH_SUPPLIERS).then(() => {
                        this.supplierData = this.get_supplier(this.get_current_user.supplier_id);
                        this.setLogo(this.supplierData);
                        this.formTitle = `Bearbeiten ${this.supplierData.supplier_name}`;
                    });
                }
            },
            uploadAndPreview (request, fileList) {
                this.fileList = fileList.slice(-1);
                this.uploadedLogo.set('logo', request.raw);
            },
            handleRemove (file) {
                this.supplierData.logo = null;
                if (this.uploadedLogo.get('logo')) {
                    this.uploadedLogo.delete('logo');
                }
            },
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let formData = new FormData();

                        if (this.uploadedLogo.get('logo')) {
                            formData.append('logo', this.uploadedLogo.get('logo'));
                        }

                        Object.keys(this.supplierData).forEach(
                            (key) => {
                                if (key !== 'logo') {
                                    formData.append(key, this.supplierData[key]);
                                }
                            }
                        );
                        if (this.formAction === 'create') {
                            this.$store.dispatch(CREATE_SUPPLIER, formData).then((resp) => {
                                this.$message.success(resp.message);
                                this.$emit('canceled');
                            }).catch((resp) => {
                                this.$message.error(resp.message);
                            });
                        } else {
                            this.$store.dispatch(UPDATE_SUPPLIER, {
                                id: formData.get('id'),
                                formData: formData
                            }).then((resp) => {
                                this.$message.success(resp.message);
                                this.supplierData.logo = resp.data.logo;
                                this.$emit('canceled');
                            }).catch((resp) => {
                                this.$message.error(resp.message);
                            });
                        }
                    }
                });
            },
            cancelForm (formName) {
                if (this.user_is_admin) {
                    this.$emit('canceled');
                } else {
                    //this.$refs[formName].resetFields();
                }
            },
            setLogo (supplier) {
                if (supplier.logo) {
                    this.fileList.push({ url: supplier.logo });
                    this.uploadedLogo.set('logo', supplier.logo);
                }
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/pages/suppliers/SupplierForm.vue